import { Component, Optional, Self } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ControlBase } from '../../base/control.base';
import { DateRange } from '../models/date-range.interface';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { NgControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { parseDate } from '../functions/parse-date.function';

@Component({
  selector: 'cec-date-range-picker',
  standalone: true,
  imports: [MatFormFieldModule, MatLabel, MatDatepickerModule, MatInputModule, TranslateModule],
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss', '../../shared/input.styles.scss'],
})
export class DateRangePickerComponent extends ControlBase<DateRange> {

  constructor(@Optional() @Self() public ngControl: NgControl, private dateAdapter: DateAdapter<Date>) {
    super(ngControl);
    // this.dateAdapter.setLocale('de-DE');
  }
  
  /** @inheritdoc */
  protected getControlValue(): DateRange {
    return this.value;
  }

  /** @inheritdoc */
  protected setControlValue(val: DateRange): void {
    if (!val) {
      return null;
    }

    this.value = val;
  }

  /** @inheritdoc */
  protected setControlDisabled(isDisable: boolean): void {
    this.isDisabled.set(isDisable);
  }

  /**
   * Sets value of the control
   * @param dateRangeStart the start of date range
   * @param dateRangeEnd the end of date range
   */
  protected dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    const value: DateRange = {start: parseDate(dateRangeStart.value), end: parseDate(dateRangeEnd.value)};  
    this.ngControl?.control?.setValue(value);
  }

  /** @inheritdoc */
  protected override afterValueWrite(): void {
    this.ngControl?.control?.updateValueAndValidity();
  }
}
